import { render, staticRenderFns } from "./indexA.vue?vue&type=template&id=774a5e9a&scoped=true&"
import script from "./indexA.vue?vue&type=script&lang=js&"
export * from "./indexA.vue?vue&type=script&lang=js&"
import style0 from "./indexA.vue?vue&type=style&index=0&id=774a5e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a5e9a",
  null
  
)

export default component.exports